import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Hero from "../common/Hero";
import Headerstart from "../common/Headerstart";

const BookingPage = () => {
  return (
    <>
      <Header />
      <Headerstart link={"Bookings"} />
      <Hero />
      <Footer />
    </>
  );
};

export default BookingPage;
